import { Star } from "lucide-react";

const PHONE = "351910327990";
const WHATSAPP_URL = `https://wa.me/${PHONE}?text=${encodeURIComponent(
  "Olá Tamara! Gostava de fazer uma marcação."
)}`;
const GOOGLE_URL = "https://maps.app.goo.gl/CH8SZi25aTY5fSnw9";

const GoogleG = ({ className = "w-6 h-6" }) => (
  <svg viewBox="0 0 48 48" className={className} aria-hidden>
    <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8c-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4C12.955 4 4 12.955 4 24s8.955 20 20 20s20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z"/>
    <path fill="#FF3D00" d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4C16.318 4 9.656 8.337 6.306 14.691z"/>
    <path fill="#4CAF50" d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238A11.91 11.91 0 0 1 24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z"/>
    <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303a12.04 12.04 0 0 1-4.087 5.571l.003-.002l6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z"/>
  </svg>
);

const WhatsAppIcon = ({ className = "w-6 h-6" }) => (
  <svg viewBox="0 0 32 32" className={className} aria-hidden fill="currentColor">
    <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.99 2.722.99.345 0 2.476-.546 2.476-1.836 0-.214 0-.43-.06-.62-.155-.347-1.06-.6-1.405-.762-.43-.214-.86-.345-1.288-.515-.243-.097-.526-.07-.71-.31z"/>
    <path d="M16.057 0C7.196 0 0 7.196 0 16.057c0 2.872.787 5.722 2.278 8.213L0 32l7.974-2.21A16.013 16.013 0 0 0 16.057 32C24.918 32 32 24.918 32 16.057S24.918 0 16.057 0zm0 28.832a12.756 12.756 0 0 1-6.79-1.948l-.487-.287-5.05 1.32 1.35-4.91-.317-.502a12.732 12.732 0 0 1-2.135-7.06c0-7.066 5.745-12.81 12.81-12.81a12.74 12.74 0 0 1 9.083 3.764 12.73 12.73 0 0 1 3.764 9.083c0 7.066-5.745 12.81-12.81 12.81z"/>
  </svg>
);

const FloatingActions = () => {
  return (
    <div
      className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3"
      data-testid="floating-actions"
    >
      {/* Google */}
      <a
        href={GOOGLE_URL}
        target="_blank"
        rel="noreferrer"
        data-testid="floating-google-btn"
        aria-label="Ver avaliações no Google"
        className="group flex items-center gap-3 bg-white shadow-[0_10px_40px_-10px_rgba(0,0,0,0.35)] pl-2 pr-4 py-2 hover:shadow-[0_15px_50px_-10px_rgba(218,165,32,0.5)] hover:-translate-x-1 transition-all duration-300 rounded-full"
      >
        <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center">
          <GoogleG className="w-5 h-5" />
        </div>
        <div className="flex flex-col leading-tight">
          <div className="flex items-center gap-1">
            <span className="text-[11px] font-semibold text-ink tabular-nums">5.0</span>
            <div className="flex gap-px text-gold">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-2.5 h-2.5 fill-current" />
              ))}
            </div>
          </div>
          <span className="text-[9px] uppercase tracking-wider text-ink/60">Google</span>
        </div>
      </a>

      {/* WhatsApp */}
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noreferrer"
        data-testid="floating-whatsapp-btn"
        aria-label="Falar no WhatsApp"
        className="relative group bg-[#25D366] text-white w-14 h-14 rounded-full flex items-center justify-center shadow-[0_10px_40px_-10px_rgba(37,211,102,0.6)] hover:shadow-[0_15px_50px_-10px_rgba(37,211,102,0.8)] hover:scale-110 transition-all duration-300"
      >
        <WhatsAppIcon className="w-7 h-7" />
        <span aria-hidden className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 animate-ping" />
      </a>
    </div>
  );
};

export default FloatingActions;
